import { Component, OnInit, OnDestroy, ViewChild, ElementRef, NgZone, Renderer } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { Router, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { HttpService } from '../../service/http.service';
import { UserPlanService } from '../../service/userplan.service';
import { AppState } from '../../models/app.state';
import { Store } from '@ngrx/store';
import { PostFilterService } from '../../service/post-filter.service';
import { environment } from '../../../environments/environment';
import { eventEmitterService } from '../../service/eventEmitter.service';
import {UserService} from "../../service/user.service";
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';


declare var $: any;

@Component({
  selector: 'app-createbuilding',
  templateUrl: './createbuilding.component.html',
  styleUrls: ['./createbuilding.component.css']
})
export class CreatebuildingComponent implements OnInit {

  address: any = {};
  inputAddress;
  reportCoop: FormGroup;
  modalWindow;
  unregisteredAddress;
  submited: boolean;
  modalDismiss: string;
  coords: Object = {};
  imageUrl;
  error;
  addressInput;
  place: google.maps.places.PlaceResult;
  isLoadingActive = false;
  isSuccess = false;
  successMessage: string;
  alert;
  ModalTrigger = false;
  modalToOpen;
  modalTarget;
  errorState: boolean = false;
  isReportToMycoop:boolean = false;
  userPlan;
  href : string = "";
  isAddressBarPageOrPopup = 'addressBarPage';

  emailInvalid = false;
  commentInvalid = false;
  submitted:boolean = false;

  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;

  @ViewChild('submitbuild', { static: false })
  public submit: ElementRef;

  @ViewChild('loginButton', { static: false })
  public log: ElementRef;
  test;
  isManagerStatus;
  replaceBuildingByRes = false;

  tags:string[]  = ['AngularJS','Angluar2']
  private url = environment.apiUrl;

  constructor(private mapsAPILoader: MapsAPILoader,
              private ngZone: NgZone,
              private router: Router,
              private _http: HttpClient,
              private _fb: FormBuilder,
              private httpService: HttpService,
              private plan: UserPlanService,
              private userService : UserService,
              private store: Store<AppState>,
              private emitter: eventEmitterService,
              private renderer: Renderer,
              private route: ActivatedRoute,
              private param: PostFilterService) { }

  ngOnInit() {

    this.href = this.router.url;

    /**
     * google api address search section
     */
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: []
      });
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          //get the place result
          this.error = null;
          this.place = null;

          this.place = autocomplete.getPlace();
          //console.log(this.place, "===============");
          this.addressInput = this.place.formatted_address;

          this.renderer.listen(this.submit.nativeElement, 'click', (event) => {

            this.address.adr_address = this.place['adr_address'];
            this.address.formattedAddress = this.place.formatted_address;
            this.address.coords = {
              lat: this.place.geometry.location.lat(),
              lng: this.place.geometry.location.lng()
            };
            this.address.placeId = this.place.place_id;
            this.buildingSearchAndCreate(this.address);
          });
        });
      });
    }).catch((error)=>{
      //$('#myModal').modal('show');
    });

  }

  ngOnDestroy(){

  }

  buildingSearchAndCreate(address) {
    this._http.post(`${this.url}auth/buildingCreateDynamically`, address, { withCredentials: true })
      .pipe(
        map((res: any) => res) // You can modify this if needed, since Angular 6 automatically handles JSON
      )
      .subscribe(
        (res) => {
          console.log("===========User Create Building===============", res);
        },
        (error) => {
          console.error("Error creating building: ", error);
        }
      );
  }

}
